// src/components/legal/TextoLegal.jsx
//
// El texto de un documento legal tal como llega de `routers/legal.py`: párrafos
// separados por una línea en blanco, y un bloque cuyas líneas empiezan por «· »
// es una lista. Un solo sitio para leerlo así, lo use el aviso del empleado, la
// página /privacidad o las que vengan.
//
// Dos marcas dentro del texto:
//   · los correos salen como enlace —quien lee «escríbenos a …» tiene que poder
//     hacerlo con un toque—,
//   · **así** se pinta en negrita, para el par de frases de las condiciones que
//     no se pueden leer por encima («Planes:», «pueden equivocarse»).

const TROZOS = /(\*\*[^*]+\*\*|[\w.+-]+@[\w-]+(?:\.[\w-]+)*\.[a-z]{2,})/i;

function marcado(texto) {
  return String(texto).split(TROZOS).map((trozo, i) => {
    if (i % 2 === 0) return trozo;
    if (trozo.startsWith('**')) return <strong key={i}>{trozo.slice(2, -2)}</strong>;
    return <a key={i} href={`mailto:${trozo}`}>{trozo}</a>;
  });
}

export default function TextoLegal({ texto }) {
  return String(texto || '').split('\n\n').map((bloque, i) => {
    const lineas = bloque.split('\n');
    if (lineas.every((l) => l.startsWith('· '))) {
      return <ul key={i}>{lineas.map((l, j) => <li key={j}>{marcado(l.slice(2))}</li>)}</ul>;
    }
    return <p key={i}>{marcado(bloque)}</p>;
  });
}
